import installer from './../../components/svgs/installer.jsx';
import consumer from './../../components/svgs/consumer.jsx';
import programAdministrator from './../../components/svgs/program-administrator.jsx'
import consultant from './../../components/svgs/consultant.jsx';
import other from './../../components/svgs/other.jsx';

const Audiences = {
    input: {
        name: 'audiences',
        type: 'radio',
        values: [
            {
                title: 'Installer',
                value: 'installer',
                image: installer
            },
            {
                title: 'Consumer',
                value: 'consumer',
                image: consumer
            },
            {
                title: 'Program Administrator',
                value: 'program-administrator',
                image: programAdministrator
            },
            {
                title: 'Consultant',
                value: 'consultant',
                image: consultant
            },
            {
                title: 'Other',
                value: 'other',
                image: other
            }
        ]
    }
};

export default Audiences;